import React from "react";
import { Coins, Star, Swords, PiggyBank } from "lucide-react";

const LESSONS = [
  { id: "money", Icon: Coins, color: "bg-emerald-500 border-emerald-700", title: "Make money", text: "Set smart prices, buy supplies, and learn that Profit = what you earn − what you spend." },
  { id: "reviews", Icon: Star, color: "bg-amber-400 border-amber-600", title: "Get great reviews", text: "Happy, safe customers leave 5 stars. Better reviews bring more customers tomorrow." },
  { id: "compete", Icon: Swords, color: "bg-rose-500 border-rose-700", title: "Compete with Riley", text: "Your rival watches your prices and reviews. Beat Riley's week to win a Top Boss trophy." },
  { id: "save", Icon: PiggyBank, color: "bg-sky-500 border-sky-700", title: "Save & earn interest", text: "Drop cash into your Piggy Bank and watch it grow 5% every day. Saving pays!" },
];

const LearnGrid = () => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="landing-learn">
    <div className="grid lg:grid-cols-12 gap-8 items-start">
      <div className="lg:col-span-4">
        <div className="text-xs font-black uppercase tracking-widest text-amber-600 mb-2">What you&apos;ll learn</div>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 tracking-tight">Real money skills, disguised as fun</h2>
        <p className="mt-4 text-sm sm:text-base text-slate-600 font-medium leading-relaxed">
          Every job teaches something a real business owner needs to know — with quizzes, lessons and coins along the way.
        </p>
      </div>
      <div className="lg:col-span-8 grid sm:grid-cols-2 gap-4">
        {LESSONS.map((l, i) => (
          <div key={l.id} className="bg-white rounded-3xl border-2 border-slate-200 p-5 card-3d flex gap-4 animate-pop-in" style={{ animationDelay: `${i * 100}ms` }} data-testid={`landing-learn-${l.id}`}>
            <div className={`${l.color} text-white rounded-2xl p-3 border-b-4 h-fit shrink-0`}>
              <l.Icon className="w-6 h-6" strokeWidth={2.5} />
            </div>
            <div>
              <h3 className="font-display text-lg sm:text-xl font-bold text-slate-900">{l.title}</h3>
              <p className="text-sm text-slate-600 font-medium mt-1 leading-relaxed">{l.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default LearnGrid;
